function pollyfillLocalStorage() {
  let data = {};

  return {
    setItem(key, val) {
      data[key] = String(val);
    },
    getItem(key) {
      return data.hasOwnProperty(key) ? data[key] : null;
    },
    removeItem(key) {
      delete data[key];
    },
    clear() {
      data = {};
    }
  };
}

const localStorage = window.localStorage || pollyfillLocalStorage();

export default {
  set(key, val) {
    return localStorage.setItem(key, JSON.stringify(val));
  },
  get(key) {
    const val = localStorage.getItem(key);
    if (val === null) return null;
    return JSON.parse(val);
  },
  remove(key) {
    return localStorage.removeItem(key);
  },
  clear() {
    return localStorage.clear();
  }
};



// WEBPACK FOOTER //
// ./src/utils/localStorage.js